<template>
  <div>
    <div v-wechat-title="$tm('index2024.live.title')" />
    <gc-skeleton :is-show="loading" />
    <gc-guide :down-show="guideShow" @showDwon="getGuideStatus" />
    <ShareInfo :share-info="shareData" />
    <Banner type="live" />
    <div class="index_content">
      <p class="index_rule">
        {{ $tm(`index2024.${pathInfo.type}.tip`) }}
      </p>
      <ul class="live_list mt20">
        <li 
          v-for="(item,i) in listData" 
          :key="item.id" 
          class="list_item rds4" 
          @click="goPath('liveview', item)"
        >
          <div class="item_top">
            <video
              preload="none"
              :src="item.video"
              x5-playsinline=""
              playsinline=""
              webkit-playsinline=""
              :poster="item.img1"
              class="video_img"
              @click="onPause()"
            />
            <div :class="'ranking ranking'+item.sort"><span class="ft_bm">TOP</span> <i class="ft_bm">{{ addZero(item.sort) }}</i></div>
            <!-- 收藏 -->
            <div class="collect">
              <span v-if="item.liked" class="followBtn rds48 followBtnEnd" @click.stop="like(item, 'likeDelTo2024', 0)">{{ $tm(`index2024.savedText`) }}</span>
              <span v-else class="followBtn rds48" @click.stop="like(item, 'likeAddTo2024', 1)">{{ $tm(`index2024.saveText`) }}</span>
            </div>
            <div class="bg_play" @click.stop="onPlay(item, i)" />
          </div>
          <div class="item_bottom">
            <h3 class="text_overflow2 font_bold">{{ item.title }}</h3>
            <div class="bottom_info">
              <!-- @click="goPath('userview', item)" -->
              <div class="user_info">
                <span class="label">主播：</span>
                <div class="user_pic">
                  <!-- TODO 主播可能存在多人头像 -->
                  <img :src="item.img2" alt="img" class="user">
                  <!-- <img :src="item.avatar" alt="img" class="user"> -->
                  <!-- <img v-if="item.auth_icon" :src="item.auth_icon" alt="img" class="user_vip"> -->
                </div>
                <span class="text_over">
                  {{ item.data.anchor_nickname }}
                </span>
              </div>
              <!-- 热度 -->
              <div class="hot_black"> <span class="ft_bm"> {{ item.num1 }}</span>人观看</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <SideMenu :type="pathInfo.type" />
    <Footer />
  </div>
</template>

<script>
import config from '@/config/config'
import { ajaxHttp } from '@/api/api'
import utils, { addZero } from '@/utils/utils'
import { superLink, checkloginCallback, platformType } from '@/utils/index'

import { Toast } from 'vant'
import Banner from '../components/banner'
import Footer from '../components/footer'
import SideMenu from '../components/sideMenu'
import ShareInfo from '@/components/shareInfo'
import GcGuide from '@/components/gc-guide'
import GcSkeleton from '@/components/gc-skeleton'

export default {
  name: 'Live',
  components: {
    Banner,
    Footer,
    SideMenu,
    ShareInfo,
    GcGuide,
    GcSkeleton
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    this.onPause()
    next()
  },
  data() {
    return {
      loading: true, // 接口loading效果
      guideShow: false, // 微信点击的引导提示框
      pathInfo: {}, // 页面路径传参
      listData: [], // 列表数据
      shareData: { // 分享数据
        share_title: '',
        share_des: '',
        share_link: '',
        share_img: ''
      },
      videoElement: [],
      btnElement: []
    }
  },
  created() {
    const { query } = this.$route
    this.pathInfo = query
    this.getListData()
    this.shareData = {
      share_title: this.$tm(`index2024.${query.type}`).share_title,
      share_desc: this.$tm(`index2024.${query.type}`).share_des,
      share_link: location.href,
      share_img: 'https://static.mingchu.co/webapp/index2024/share/live.png'
    }

    if (utils.getQueryVariable('token')) {
      this.shareData.share_title = '盘点 2024 最受关注的直播内容' 
      this.shareData.share_img = 'https://static.mingchu.co/webapp/index2024/minishare/live.png'
    }
  },
  mounted() {
    window.scroll(0, 0)
    window.mitt.on('guideShow', ($info) => { // 监听微信内点击弹起引导提示框
      this.guideShow = $info
    })
    this.videoElement = document.getElementsByTagName('video') // 获取页面上所有的video对象
    this.btnElement = document.getElementsByClassName('bg_play') // 获取页面上所有的video对象

    /* eslint-disable */
    sensors.track('MCINDEX2024_visit', {
      MCINDEX_title: 'live',
      from: '2024指数_最受关注直播页面访问量',
      PlatformType: platformType()

    })
  },
  deactivated() {
    this.$forceUpdate(0)
  },
  destroyed() {
    window.mitt.off('guideShow') // 销毁
  },
  methods: {
    addZero,
    onPause() {
      // const arr = this.videoElement.length
      // for (let i = 0; i < arr; i++) {
      //   this.videoElement[i].pause()
      //   this.btnElement[i].style.display = 'block'
      // }
    },
    onPlay(item, $i) {
      console.log('开始播放')
      // 埋点
      // const arr = this.videoElement.length
      // for (let i = 0; i < arr; i++) {
      //   if (i === $i) {
      //     this.videoElement[$i].play()
      //     this.btnElement[$i].style.display = 'none'
      //   } else {
      //     this.videoElement[i].pause()
      //     this.btnElement[i].style.display = 'block'
      //   }
      // }
    },
    // 获取列表数据
    getListData() {
      const self = this
      ajaxHttp.$get(
        '/api/ranking2024/detail', 
        { ...self.pathInfo, leader_type: self.pathInfo.type  }
      ).then(res => {
        if (res.code === 1) {
          this.listData = res.data?.leaders ?? []
        }
        this.$nextTick(() => {
          self.loading = false
        })
      })
    },
    // 收藏
    async like(item, apiType, changeStauts) {
      // 添加埋点
      sensors.track('MCINDEX2024_collect_click', {
        MCINDEX_title: this.pathInfo.type,
        from: '2024指数_最受关注直播页面收藏点击',
        PlatformType: platformType(),
      })
      // 检查app是否登录，然后执行回调函数
      checkloginCallback(async function() { // 统一的接口请求方法
          Toast.loading({ message: 'Loading...', forbidClick: true })
          const res = await ajaxHttp[apiType]({
            id: item.leader_id,
            type: '7', // 1作品 | 4内容 | 6专题 | 7直播
            plant: '2'
          })
          if (res.code == 1) { 
            item.liked = (apiType === 'likeAddTo2024' ? true : false )
          }
          Toast.clear()
        }, this // 要传进去个this
      )
    },
    goPath($des, _item) {
      // 添加埋点
      sensors.track('MCINDEX2024_card_click', {
        MCINDEX_title: this.pathInfo.type,
        from: '2024指数_最受关注直播页面卡片点击',
        card_name: _item.title,
        PlatformType: platformType(),
      })
      // JSON标准格式双引号，eslint默认单引号，冲突
      const data = `{
        "des": "${$des}", 
        "skuid": "${_item.leader_id}",
        "link": "${config.webapplink}/${$des}?id=${_item.leader_id}"
      }`
      return superLink(data)
    },
    getGuideStatus(val) { // 获取子组件的返回
      this.guideShow = false
    }
  }
}
</script>
